module.exports = __webpack_public_path__ + "img/FW_Wingblade.182853f0.png";